import config from 'config';

export const MIN_AUTO_COMPARE_LIMIT = 1;
export const MAX_AUTO_COMPARE_LIMIT = 500;
export const DEFAULT_AUTO_COMPARE_LIMIT = 5;

export const ADD_TO_COMPARE_LIMIT = config.compareRunsLimit ?? 200;
export const HIDDEN_IN_COMPARE_LIMIT = 100;
